import { createApi } from '@reduxjs/toolkit/query/react'
import {baseQuery} from "../baseQuery";

const refetchSeconds = process.env.REACT_APP_REFETCH_SECONDS ? parseInt(process.env.REACT_APP_REFETCH_SECONDS) : 30;

export const seasonsApi = createApi({
    reducerPath: 'seasonsApi',
    baseQuery,
    tagTypes: ["seasons", "season"],
    keepUnusedDataFor: 300,
    refetchOnMountOrArgChange: refetchSeconds,
    endpoints: (builder) => ({
        getSeasons: builder.query({
            query: () => ({url: `seasons`}),
            providesTags: ['seasons']
        }),
        getSeasonByYearAndName: builder.query({
            query: ({year, name}) => ({url: `seasons/${year}/${name}`}),
            providesTags: ['season']
        }),
        getAnimeOfSeason: builder.query({
            query: ({slug, page = 1}) => ({url: `seasons/${slug}/anime/${page}`}),
            providesTags: ['season']
        }),
        getAllAnimeOfSeason: builder.query({
            query: ({slug}) => ({url: `seasons/${slug}/anime`}),
            providesTags: ['season']
        })
    })
});

export const {
    useLazyGetSeasonsQuery,
    useLazyGetSeasonByYearAndNameQuery,
    useLazyGetAnimeOfSeasonQuery,
    useLazyGetAllAnimeOfSeasonQuery
} = seasonsApi;
